export const INCIDENT_BUCKETS = ['A', 'B', 'C']

export const INCIDENT_BUCKET_LABELS: Record<string, string> = {
  A: 'A-feil',
  B: 'B-feil',
  C: 'C-feil',
}

export const PLANNED_BUCKETS = ['Høy', 'Medium', 'Lav']
